<div class="app__mx--taskbar gap-4">
  @if (minimizedDialogs.length) {
    @for (dialog of minimizedDialogs; track dialog.dialogId; let index = $index) {
      <div
        class="app__taskbar--cards"
        [style.width.px]="minimizedWidth"
        [style.maxWidth.px]="minimizedWidth"
        [ngClass]="{
          'app__taskbar--cards--completed': dialog.status === 'completed',
          'app__taskbar--cards--in-progress': dialog.status !== 'completed'
        }"
        (click)="maximizeMxDialog(dialog)"
      >
        <div
          [ngStyle]="{ '--resizedWidth': minimizedWidth + 'px' }"
          class="app__text--overflow flex min-w-0 w-[calc(var(--resizedWidth)-54px)] items-center justify-start"
        >
          <span
            class="app__form--attribute--title block overflow-hidden text-ellipsis whitespace-nowrap text-base font-semibold tracking-[-0.08px]"
            >{{ dialog.data?.institutionName }}</span
          >
        </div>
        <div class="flex shrink-0 items-center justify-end">
          <span class="hover:cursor-pointer" (click)="maximizeMxDialog(dialog); $event.stopPropagation()">
            <img
              class="size-[18px]"
              [src]="
                dialog.status === 'completed'
                  ? 'assets/images/mx-expand-icon-white.svg'
                  : 'assets/images/mx-expand-icon.svg'
              "
              alt="Expand"
            />
          </span>
        </div>
      </div>
    }
  }
</div>
